var _path, _rect, _rect2, _rect3, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 4.08464C9.57217 4.08464 9.83333 4.3458 9.83333 4.66797V11.668C9.83333 11.9901 9.57217 12.2513 9.25 12.2513H4C3.67783 12.2513 3.41667 11.9901 3.41667 11.668V4.66797C3.41667 4.3458 3.67783 4.08464 4 4.08464H9.25ZM11 4.66797C11 3.70147 10.2165 2.91797 9.25 2.91797H4C3.0335 2.91797 2.25 3.70147 2.25 4.66797V11.668C2.25 12.6345 3.0335 13.418 4 13.418H9.25C10.2165 13.418 11 12.6345 11 11.668V4.66797Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.58398,
    y: 5.25,
    width: 4.08333,
    height: 1.16667,
    rx: 0.583333,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.58398,
    y: 7.58203,
    width: 4.08333,
    height: 1.16667,
    rx: 0.583333,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.58398,
    y: 9.91797,
    width: 2.33333,
    height: 1.16667,
    rx: 0.583333,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1673 2.33203C12.1673 2.00986 11.9062 1.7487 11.584 1.7487H6.33398C6.01182 1.7487 5.75065 2.00986 5.75065 2.33203V2.91536H4.58398V2.33203C4.58398 1.36553 5.36749 0.582031 6.33398 0.582031H11.584C12.5505 0.582031 13.334 1.36553 13.334 2.33203V9.33203C13.334 10.2985 12.5505 11.082 11.584 11.082H11.0007V9.91536H11.584C11.9062 9.91536 12.1673 9.6542 12.1673 9.33203V2.33203Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "media/book.de8b8210.svg";
export { ForwardRef as ReactComponent };